import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp, FaExternalLinkAlt } from 'react-icons/fa';
import './FAQ.css';

const FAQ = () => {
  const [openItems, setOpenItems] = useState([]);

  const faqItems = [
    {
      id: 1,
      question: 'Não encontrei a bateria para o meu carro. E agora?',
      answer: 'Entre em contato conosco pelo WhatsApp ou telefone. Nossa equipe técnica irá identificar a bateria correta para o seu veículo através do modelo, ano e especificações.'
    },
    {
      id: 2,
      question: 'E se o problema não for bateria?',
      answer: 'Nossos técnicos são especializados e podem diagnosticar outros problemas elétricos do seu veículo. Caso não seja a bateria, você não paga nada pela visita técnica.'
    },
    {
      id: 3,
      question: 'Como faço para realizar o pagamento?',
      answer: 'Aceitamos cartão de crédito/débito, dinheiro e PIX. O pagamento é realizado apenas na entrega e instalação da bateria, após a confirmação de que está funcionando perfeitamente.'
    },
    {
      id: 4,
      question: 'Qual o prazo de entrega?',
      answer: 'Nossa entrega é realizada em até 50 minutos após a confirmação do pedido, dependendo da sua localização. Em casos especiais, pode levar até 2 horas.'
    },
    {
      id: 5,
      question: 'A instalação é gratuita?',
      answer: 'Sim! A instalação é totalmente gratuita e realizada por técnicos especializados. Você não paga nada além do valor da bateria.'
    },
    {
      id: 6,
      question: 'Qual a garantia da bateria?',
      answer: 'Oferecemos garantia de 15 meses para todas as baterias, conforme especificação do fabricante. Em caso de defeito, trocamos sem custo adicional.'
    }
  ];

  const toggleItem = (id) => {
    setOpenItems(prev => 
      prev.includes(id) 
        ? prev.filter(item => item !== id)
        : [...prev, id]
    );
  };

  return (
    <section className="faq" id="faq">
      <div className="container">
        <div className="faq-content">
          <div className="faq-header">
            <h2 className="faq-title">
              Dúvidas? Nós te ajudamos!
            </h2>
          </div>
          
          <div className="faq-list">
            {faqItems.map((item) => (
              <div key={item.id} className="faq-item">
                <button 
                  className="faq-question"
                  onClick={() => toggleItem(item.id)}
                >
                  <span>{item.question}</span>
                  {openItems.includes(item.id) ? (
                    <FaChevronUp className="faq-icon" />
                  ) : (
                    <FaChevronDown className="faq-icon" />
                  )}
                </button>
                
                {openItems.includes(item.id) && (
                  <div className="faq-answer">
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
          
          <div className="faq-more">
            <a href="#mais-duvidas" className="more-link">
              Ver mais dúvidas
              <FaExternalLinkAlt className="link-icon" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
